const topics = [
  { 
    title: "Matter Rock", standardNumber: "2-PS1-1", slug: "matterrock",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmatterrock2025video.mp4?alt=media&token=9dcb63a2-cfea-49ca-8cc7-0d30700ecab3 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmatterrock2025song.mp3?alt=media&token=78f1e7a9-8c65-4b5a-8489-430d502eb06c ",
    lyrics: ["(Chorus)",
  "Matter has mass and takes up space.",
  "Matter has mass and takes up space.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  
  "(Verse)",
  "Solids, they keep their shape.",
  "Solids, they keep their shape.",
  "Particles are packed tightly in solids, vibrating.",
  "Particles are packed tightly in solids, vibrating.",
  
  "Liquids take the shape of its container.",
  "Liquids take the shape of its container.",
  "Particles are spread out a little, sliding past each other.",
  "Particles are spread out a little, sliding past each other.",
  
  "In gases, the shape will change with its container.",
  "In gases, the volume will change with its container.",
  "Particles are spread out and move very quickly.",
  "Particles are spread out and move very quickly.",
  
  "(Chorus)",
  "Matter has mass and takes up space.",
  "Matter has mass and takes up space.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Properties of Matter", standardNumber: "2-PS1-1", slug: "propertiesofmatter",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Conductors", standardNumber: "2-PS1-2", slug: "conductors",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fconductors2025video.mp4?alt=media&token=575ccfe3-62fb-426b-ad44-5882b54eb356 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fconductors2025song.mp3?alt=media&token=1c1e3505-da36-40da-ae69-d7daa4f17d19 ",
    lyrics: ["(chorus)",
  "Conductors and insulators.",
  "Conductors and insulators.",
  "Conductors and insulators.",
  "Conductors and insulators.",
  
  "(verse 1)",
  "What makes materials conduct electricity?",
  "When electrons jump.",
  "What makes materials conduct electricity?",
  "When electrons jump from one atom,",
  "into an empty space of another atom.",
  "The moving of electrons causes electrical currents.",
  "Insulator, a material that electrical charges cannot move through,",
  "cannot move through.",
  "Conductor, a material that electrical charges easily flow through,",
  "flow through.",
  "Copper, conductor.",
  "Gold, conductor.",
  "Rubber, insulator.",
  "Styrofoam, insulator.",
  
  "(chorus)",
  "Conductors and insulators.",
  "Conductors and insulators.",
  "Conductors and insulators.",
  "Conductors and insulators.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "", standardNumber: "2-PS1-3", slug: "",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "3 States of Matter", standardNumber: "2-PS1-4", slug: "3statesofmatter",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3statesofmatter2025video.mp4?alt=media&token=a521644b-b4eb-4a56-89e2-2beb95c71ad7 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3statesofmatter2025song.mp3?alt=media&token=4ca634b8-d275-41d6-9e49-36d59970db1b ",
    lyrics: ["(Chorus)",
  "Matter is everything around you.",
  "Matter is made of atoms and molecules.",
  "3 states: solids, liquids, gases.",
  "3 states: solids, liquids, gases.",
  
  "(Verse)",
  "Solids, yes, are hard.",
  "Liquids are more like water.",
  "Gases are like the atmosphere,",
  "That surrounds the earth, our air.",
  "Solids, yes, are hard.",
  "Liquids are more like water.",
  "Gases are like the atmosphere,",
  "That surrounds the earth, our air.",
  "Those are the 3 states of matter,",
  "Those are the 3 states of matter.",
  "Solids, liquids, gases.",
  "Solids, liquids, gases.",
  
  "(Chorus)",
  "Matter is everything around you.",
  "Matter is made of atoms and molecules.",
  "3 states: solids, liquids, gases.",
  "3 states: solids, liquids, gases.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Melting, Boiling, Freezing Points", standardNumber: "2-PS1-4", slug: "meltingboilingfreezingpoints",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmeltingboilingfreezing2025song.mp3?alt=media&token=3bb7cd69-462c-4be6-a8ec-a213b28bde31 ",
    lyrics: ["(Chorus)",
  "Matter has mass and takes up space.",
  "Matter has mass and takes up space.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  
  "(Verse)",
  "Solids, they keep their shape.",
  "Solids, they keep their shape.",
  "Particles are packed tightly in solids, vibrating.",
  "Particles are packed tightly in solids, vibrating.",
  
  "Liquids take the shape of its container.",
  "Liquids take the shape of its container.",
  "Particles are spread out a little, sliding past each other.",
  "Particles are spread out a little, sliding past each other.",
  
  "In gases, the shape will change with its container.",
  "In gases, the volume will change with its container.",
  "Particles are spread out and move very quickly.",
  "Particles are spread out and move very quickly.",
  
  "(Chorus)",
  "Matter has mass and takes up space.",
  "Matter has mass and takes up space.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  "Three states of matter,",
  "Solid, liquid, and gas.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Heating & Cooling", standardNumber: "2-PS1-4", slug: "heatingandcooling",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fheatingandcooling2025song.mp3?alt=media&token=f9370550-3077-42ee-a0a0-a8a01a268baa ",
    lyrics: ["(chorus)",
  "Heat it up, cool it down,",
  "Watch the changes all around!",
  "Liquids to gas, or solid to ice,",
  "Heating and cooling, science is nice!",
  
  "(verse)",
  "Add some heat, water turns to steam,",
  "It floats in the air like a misty dream.",
  "Cool it down, and watch it fall,",
  "Rain turns to puddles, that’s not all!",
  "Heat melts butter, chocolate too,",
  "Cooling makes them hard, it’s what they do!",
  "Ice turns to water, then back again,",
  "Heating and cooling are science friends!",
  
  "(chorus)",
  "Heat it up, cool it down,",
  "Watch the changes all around!",
  "Liquids to gas, or solid to ice,",
  "Heating and cooling, science is nice!",
  
  "(verse)",
  "Evaporation makes water disappear,",
  "Heating it up sends it out of here!",
  "Cooling it down makes it come back,",
  "Forming clouds or frost, on nature’s track.",
  "So heat it up, and cool it too,",
  "Changes in matter are fun to do.",
  "Evaporation, melting, freezing, it’s true,",
  "Heating and cooling teach me and you!",
  
  "(chorus)",
  "Heat it up, cool it down,",
  "Watch the changes all around!",
  "Liquids to gas, or solid to ice,",
  "Heating and cooling, science is nice!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Things Plants Need", standardNumber: "2-LS2-1", slug: "thingsplantsneed",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthingsplantsneed2025video.mp4?alt=media&token=13010d5d-3513-42e1-88ef-e35908d024cd ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthingsplantsneed2025song.mp3?alt=media&token=58839d9c-7e4f-40c7-bd9b-66865d87379b ",
    lyrics: ["(Chorus)",
  "What do plants need? Let’s find out!",
  "Water, air, and light, no doubt.",
  "Shelter and space to grow up tall,",
  "Plants need these to give us all!",
  
  "(Verse 1)",
  "Plants need water to drink each day,",
  "It helps their roots in every way.",
  "They reach for light from the sun so bright,",
  "It helps them grow both day and night!",
  
  "(Chorus)",
  "What do plants need? Let’s find out!",
  "Water, air, and light, no doubt.",
  "Shelter and space to grow up tall,",
  "Plants need these to give us all!",
  
  "(Verse 2)",
  "Air is around, it helps them breathe,",
  "It’s one more thing that plants do need.",
  "With space to stretch and shelter near,",
  "They grow so strong, year after year!",
  
  "(Bridge)",
  "Roots in the ground, leaves to the sky,",
  "Plants grow tall and reach up high.",
  "They need these things, it’s easy to see,",
  "Water, air, light, and space are key!",
  
  "(Chorus)",
  "What do plants need? Let’s find out!",
  "Water, air, and light, no doubt.",
  "Shelter and space to grow up tall,",
  "Plants need these to give us all!",
  
  "(Outro)",
  "So care for the plants, give them their space,",
  "Water and sunlight in the right place.",
  "Watch them grow, it’s fun to see,",
  "Plants are special for you and me!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "What Do Plants Need", standardNumber: "2-LS2-1", slug: "whatdoplantsneed",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwhatdoplantsneed2025video.mp4?alt=media&token=2172b66c-8868-45bf-8a14-dd8f6be2f4ec ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatdoplantsneed2025song.mp3?alt=media&token=95132d97-2377-471a-9d92-9562b9dec2e7 ",
    lyrics: ["(Chorus)",
  "Plants and animals change as they grow.",
  "There are a few things we know",
  "That they need for survival.",
  
  "(Verse 1)",
  "Animals need food and water.",
  "Animals need food and water.",
  "Animals need air and shelter.",
  "Animals need air and shelter.",
  "Some animals get their oxygen from the air.",
  "That makes them terrestrial.",
  "Some animals get their oxygen from the water.",
  "That makes them aquatic.",
  
  "(Chorus)",
  "Plants and animals change as they grow.",
  "There are a few things we know",
  "That they need for survival.",
  
  "(Verse 2)",
  "Plants need air, light, water, and nutrients from the soil.",
  "Plants need air, light, water, and nutrients from the soil.",
  "Plants provide food for people.",
  "Plants provide food for animals.",
  "Plants can be aquatic.",
  "Plants can be terrestrial.",
  
  "(Chorus)",
  "Plants and animals change as they grow.",
  "There are a few things we know",
  "That they need for survival.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Plant Life Cycle", standardNumber: "2-LS2-1", slug: "plantlifecycle",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplantlifecycle.mp4?alt=media&token=04c5304e-ef30-4fec-b739-882b2fd418ab ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantlifecycle.mp3?alt=media&token=20abb63d-b1eb-4ab8-b653-4bd0e6bffc81 ",
    lyrics: ["(chorus)",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  
  "(verse)",
  "Now, all plant seeds have an outer cover called a seed coat,",
  "to protect the plant inside the seed called the embryo.,",
  "When the seed germinates, the root bust out then start growing down.,",
  "Then the seed germinates, the shoot bust out, grows up above the ground.,",
  "Now it’s a sprout right there.,",
  "With help from the water, soil, sun, and air,",
  "the plant becomes a seedling.,",
  "A small plant with a few leaves.,",
  "The next stage is a young adult plant.,",
  "Over time it becomes a full adult plant.,",
  "Then you’ll see the flowers or spores,",
  "used to reproduce and make more,,",
  "and make more,,",
  "through pollination.,",
  
  "(chorus)",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  "Plant life cycle, oh-wo-wo- oh -wo-wo.,",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Plant Parts", standardNumber: "2-LS2-1", slug: "plantparts",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantparts2025song.mp3?alt=media&token=64dfa273-9473-4f12-ae5f-d08c8e11a18c ",
    lyrics: ["(chorus)",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  
  "(verse)",
  "Plant Parts",
  "The Roots take in the water and nutrients OK",
  "The Roots hold the Plant down, so it does not blow away",
  "Plant Parts",
  "The Stem takes the water and nutrients up to the Leaves",
  "The Leaves make food “Photosynthesis” yes their green",
  "The Flowers go through Fertilization they make the seeds",
  "The Fruit is the part that swells up and it holds the seeds",
  "The Seed is a tiny Plant called the Embryo",
  "and it's waiting to Germinate so that it can grow",
  
  "(chorus)",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Pollination", standardNumber: "2-LS2-2", slug: "pollination",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpollination2025video.mp4?alt=media&token=305d1007-8fc2-4dee-84a2-36e27f0d4e86 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpollination2025song.mp3?alt=media&token=ebc25acf-6a7e-474c-b3e8-7b916b11ee4f ",
    lyrics: ["(Chorus)",
  "My vocabulary.",
  "My vocabulary.",
  
  "(Verse)",
  "Pollination, pollination, what’s up?",
  "The transfer of pollen from one plant to another.",
  "Pollination, pollination, what’s up?",
  "The transfer of pollen from one plant to another.",
  "Fertilization is the process of reproduction by pollination.",
  "Fertilization is the process of reproduction by pollination.",
  "Pollination, pollination, what’s up?",
  "The transfer of pollen from one plant to another.",
  "Pollination, pollination, what’s up?",
  "The transfer of pollen from one plant to another.",
  "Fertilization is the process of reproduction by pollination.",
  "Fertilization is the process of reproduction by pollination.",
  
  "(Chorus)",
  "My vocabulary.",
  "My vocabulary.",
  "My vocabulary.",
  "My vocabulary.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  { 
    title: "Habitats", standardNumber: "2-LS4-1", slug: "habitats",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fhabitats2025video.mp4?alt=media&token=9d996902-5aa1-4927-bb6d-4ac291b420b2 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhabitats2025song.mp3?alt=media&token=ac676b90-d3da-45be-8dcb-f0ad121b1ba0 ",
    lyrics: ["(Chorus)",
  "Habitats are places with populations.",
  "Habitats are where plants or animals live.",
  "Habitats are places with populations.",
  "Habitats are where plants or animals live.",
  
  "(Verse)",
  "In a habitat, you will find,",
  "A group of organisms of the same kind,",
  "Living together at the same time,",
  "Living together.",
  "Now that habitat supplies food,",
  "Water, temperature just right,",
  "Minerals—that’s right,",
  "What organisms need to survive.",
  "Ants have their own habitat (ant farms).",
  "Bees have their own habitat (beehives).",
  "Fish have their own habitats (water).",
  "Toucans have a habitat (the rainforest).",
  
  "(Chorus)",
  "Habitats are places with populations.",
  "Habitats are where plants or animals live.",
  "Habitats are places with populations.",
  "Habitats are where plants or animals live.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Ecosystems All Around", standardNumber: "2-LS4-1", slug: "ecosystemsallaround",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fecosystemsallaround2025video.mp4?alt=media&token=906c039b-fa1f-445f-966c-bf78cfa3d2a3 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fecosystemsallaround2025song.mp3?alt=media&token=a82bc582-d017-4571-8774-bb25bfb95717 ",
    lyrics: ["(chorus)",
  "Ecosystems all around, let’s explore.",
  "From forests to oceans, there’s so much more!",
  "Biotic and abiotic, working together,",
  "supporting life through every weather!",
  
  "(verse 1)",
  "In the grasslands, the grass sway,",
  "Bison and birds roam all day.",
  "Small shrubs, insects, and prairie dogs too,",
  "They all need shelter, water, and food!",
  "In the ocean, fish swim with ease,",
  "Seaweed sways in the salty breeze.",
  "Ponds and lakes are home to frogs,",
  "With lily pads and swimming logs.",
  
  "(chorus)",
  "Ecosystems all around, let’s explore.",
  "From forests to oceans, there’s so much more!",
  "Biotic and abiotic, working together,",
  "supporting life through every weather!",
  
  "(verse 2)",
  "Forests are filled with towering trees,",
  "Beetles and owls in the leafy seas.",
  "Rivers and streams flow fast and free,",
  "Supporting fish and life, endlessly.",
  "Every ecosystem helps life succeed.",
  "From land to water, let’s take a look,",
  "Ecosystems are nature’s storybook!",
  
  "(chorus)",
  "Ecosystems all around, let’s explore.",
  "From forests to oceans, there’s so much more!",
  "Biotic and abiotic, working together,",
  "supporting life through every weather!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Animals Need", standardNumber: "2-LS4-1", slug: "animalsneed",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimallifecycle2025video.mp4?alt=media&token=a5f4b0b0-5ca0-436f-8d09-0b25bc2cc186 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimalneeds2025song.mp3?alt=media&token=53c6f12a-b401-47a5-b189-e4bcc774dc86 ",
    lyrics: ["(Chorus)",
  "Basic needs of animals.",
  "Basic needs of animals.",
  "Basic needs of animals.",
  "Basic needs of animals.",
  
  "(Verse 1)",
  "Basic needs of animals, no need to wonder,",
  "For animals to survive, they need food, shelter, and water.",
  "Basic needs of animals, no need to wonder,",
  "For animals to survive, they need food, shelter, and water.",
  
  "(Chorus)",
  "Basic needs of animals.",
  "Basic needs of animals.",
  "Basic needs of animals.",
  "Basic needs of animals.",
  
  "(Verse 2)",
  "Some animals need sunlight, like plants on the ground.",
  "Others need oxygen, to keep them safe and sound.",
  "Every living creature, big or small, it’s true,",
  "Depends on their environment, just like me and you.",
  
  "(Chorus)",
  "Basic needs of animals.",
  "Basic needs of animals.",
  "Basic needs of animals.",
  "Basic needs of animals.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Weathering", standardNumber: "2-ESS1-1", slug: "weathering",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fweathering2025video.mp4?alt=media&token=a9649c8d-b5b6-4180-b9f9-4b1746923164 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fweathering2025song.mp3?alt=media&token=d7242a48-cd46-42b9-8136-1dbab7e492c4 ",
    lyrics: ["(Chorus)",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  
  "(Verse)",
  "Weathering is when the rain and wind,",
  "Wears away the Earth’s surface.",
  
  "Erosion is when rocks and soil are broken down,",
  "And wears down the Earth’s surface.",
  
  "Deposition is when those broken-down rocks and minerals,",
  "Are transported to another place.",
  
  "(Chorus)",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Environmental Change", standardNumber: "2-ESS1-1", slug: "environmentalchange",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenvironmentalchange2025video.mp4?alt=media&token=ebe3afdd-fb4b-4722-8ae2-f2c469edc617 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenvironmentalchange2025song.mp3?alt=media&token=7fb064e4-0513-4dea-b929-47ff30f1e3e0 ",
    lyrics: ["(Chorus)",
  "Organisms can thrive in changing environments,",
  "If they adapt or move away, they still might stand a chance.",
  "Organisms can thrive in changing environments,",
  "But some may fail to live if they can't meet new demands.",
  
  "(Verse 1)",
  "Some organisms adapt to their surroundings' shift,",
  "They change their behaviors or grow a special gift.",
  "Adaptation.",
  "But if the change is sudden and the shift is too extreme,",
  "Some might not survive or fulfill their living dreams.",
  "Extinction.",
  "Some migrate to new spaces where conditions suit them more,",
  "While others stay and perish where they were before.",
  "Adaptation.",
  
  "(Bridge)",
  "If the food supply disappears or the water runs dry,",
  "Life can become a struggle, and many might die.",
  "But some species are resilient and can find a new way,",
  "To make a home in places where others couldn’t stay.",
  
  "(Chorus)",
  "Organisms can thrive in changing environments,",
  "If they adapt or move away, they still might stand a chance.",
  "Organisms can thrive in changing environments,",
  "But some may fail to live if they can't meet new demands.",
  
  "(Verse 2)",
  "When climates shift to heat waves or freezing snow and ice,",
  "Some species can evolve, but others pay the price.",
  "Natural Selection.",
  "If pollution fills their waters or habitats are gone,",
  "It creates new challenges to simply carry on.",
  "Survival.",
  "Genetics play a role in how species cope with change,",
  "Some will grow stronger while others fade away.",
  "Natural Selection.",
  
  "(Outro)",
  "Organisms rise or fall depending on their fate,",
  "How they respond to changes can truly resonate.",
  "Adapting or migrating, or even disappearing,",
  "The story of survival is both harsh and endearing.",
  
  "(Chorus)",
  "Organisms can thrive in changing environments,",
  "If they adapt or move away, they still might stand a chance.",
  "Organisms can thrive in changing environments,",
  "But some may fail to live if they can't meet new demands.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Surface Change", standardNumber: "2-ESS2-1", slug: "surfacechange",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsurfacechange2025video.mp4?alt=media&token=ac73c746-d5ee-470f-9d84-f04f7a4c0eb8 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsurfacechange2025song.mp3?alt=media&token=6649da82-6912-4a1a-8016-9a869576e845 ",
    lyrics: ["(chorus)",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  
  "(verse1)",
  "Now, what can affect the changes of the earth’s surface?",
  "Let’s see, that’s erosion, erosion.",
  "When rocks and soil are broken down and wear down the surface,",
  "That’s erosion, erosion.",
  "Weathering happens when rocks break apart",
  "Due to the weather, mechanical and chemical.",
  "Weathering happens when rocks break apart",
  "Due to the weather, mechanical and chemical.",
  "Mechanical weathering happens when rocks break apart",
  "Because of flowing water or ice.",
  "Mechanical weathering happens when rocks break apart",
  "Because it’s too cold or too hot.",
  "In chemical weathering, water dissolves the minerals",
  "In the rock and the rock breaks apart.",
  "In chemical weathering, water dissolves the minerals",
  "In the rock and the rock breaks apart.",
  
  "(chorus)",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  
  "(verse2)",
  "A canyon is a valley between cliffs.",
  "There’s often a river flowing through it.",
  "The river eroded the layers of rocks",
  "And weather caused erosion to occur.",
  "Mountains sit high, they’re naturally made",
  "When the earth’s crust folds into great waves.",
  "From lava, a volcanic mountain is made",
  "And erosion gives mountains their shape.",
  "It can be an earthquake that changes the shape",
  "Of the earth’s surface that starts to shake.",
  "It can be a volcano that’s opened up",
  "From which lava, gases, and rock erupt.",
  
  "(chorus)",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "My Map", standardNumber: "2-ESS2-2", slug: "mymap",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmymap2025video.mp4?alt=media&token=3291496b-9cbc-4a61-8810-acb3cacf3f99 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmymap2025song.mp3?alt=media&token=982b6c7f-d3c6-466b-9c7b-e77a491faf35 ",
    lyrics: ["(verse)",
  "When we make a map,",
  "when we make a map,",
  "we must include the title.",
  "That’s the name or kind of map.",
  "When we make a map,",
  "when we make a map,",
  "we must include the title.",
  "That’s the name or kind of map.",
  "When we make a map,",
  "when we make a map,",
  "we must include the legend.",
  "Symbols and what each one stands for.",
  "When we make a map,",
  "when we make a map,",
  "we must include the legend.",
  "Symbols and what each one stands for.",
  "When we make a map",
  "we must include a compass rose.",
  "It shows directions,",
  "North, south, east, and west.",
  "When we make a map",
  "we must include a compass rose.",
  "It shows directions,",
  "North, south, east, and west.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Earth’s Water", standardNumber: "2-ESS2-2", slug: "earthswater",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Landforms", standardNumber: "2-ESS2-2", slug: "landforms",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Flandforms2025video.mp4?alt=media&token=49584227-47f9-4e71-a18a-fe2aeb01a6ba ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flandforms2025song.mp3?alt=media&token=73a58a38-9970-412c-9327-17c270bcd5e2 ",
    lyrics: ["(chorus)",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  
  "(verse)",
  "Mountains are very high landforms.,",
  "You won’t find other landforms as tall.,",
  "A hill is a raised area of land.,",
  "A cave is a hole in a hill or a mountain.,",
  "Volcanoes have openings at the top,",
  "That let out lava—hot, melting rock.,",
  "Valleys are low areas between mountains,,",
  "Formed by glaciers or rivers over time.,",
  "A canyon is a deep valley with steep sides.,",
  "Plains are flat lands covered by the sky.,",
  "Earth has many beautiful landforms.,",
  "Earth has many beautiful landforms.,",
  
  "(chorus)",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  "What shapes landforms?,",
  "Processes from water, ice, wind, and gravity.,",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "", standardNumber: "2-ESS2-3", slug: "",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
];
export default topics;


